module.exports = __webpack_public_path__ + "img/39.18a2d874.png";